const routes = {
  login: '/',
  main: '/main',
}

export default routes
